<template>
    <section class="stock-tab">
        <p v-if="visibleStock.length === 0" class="stock-tab__empty">{{ $t('phu_production.stock.empty') }}</p>
        <StockCard v-for="item in visibleStock" :key="item.product_id" :item="item" :product="products[item.product_id]" @waste="$emit('waste', $event)" />
    </section>
</template>

<script>
import StockCard from './StockCard.vue'

export default {
    name: 'StockTab',
    components: { StockCard },
    props: {
        stock: { type: Array, required: true },
        products: { type: Object, required: true },
        search: { type: String, default: '' }
    },
    computed: {
        visibleStock() {
            const query = this.search.trim().toLowerCase()
            if (!query) {
                return this.stock
            }
            return this.stock.filter((item) => {
                const product = this.products[item.product_id]
                return product && product.name.toLowerCase().indexOf(query) !== -1
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.stock-tab {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: $phu-gap;
    align-content: start;

    &__empty {
        grid-column: 1 / -1;
        padding: 32px;
        font-family: $text;
        font-size: 1rem;
        text-align: center;
        color: $phu-text-muted;
    }
}
</style>
